module.exports = __webpack_public_path__ + "img/logo-2.2407c0ea.svg";